<!-- Notifications toggle -->
<button mat-icon-button (click)="openPanel()" #notificationsOrigin>
  @if (unreadCount > 0) {
    <span
      class="absolute left-0 right-0 top-0 flex h-3 items-center justify-center">
      <span
        class="ml-4 mt-2.5 flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-primary-600 dark:bg-primary-400 px-1 text-xs font-medium text-white">
        {{ unreadCount }}
      </span>
    </span>
  }
  <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>
  <div
    class="fixed inset-0 flex flex-col overflow-hidden shadow-lg sm:static sm:inset-auto sm:w-90 sm:min-w-90 sm:rounded-2xl">
    <!-- Header -->
    <div
      class="flex shrink-0 items-center bg-primary-600 dark:bg-primary-400 py-4 pl-6 pr-4 text-on-primary">
      <div class="-ml-1 mr-3">
        <button mat-icon-button (click)="closePanel()">
          <mat-icon
            class="text-white icon-size-5"
            [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
        </button>
      </div>
      <div class="text-lg font-medium leading-10">
        {{ 'notifications.title' | transloco }}
      </div>
      <!-- Refresh button -->
      <button
        mat-icon-button
        class="ml-auto"
        (click)="refreshNotifications()"
        [matTooltip]="'notifications.refresh' | transloco">
        <mat-icon
          class="text-white icon-size-5"
          [svgIcon]="'heroicons_solid:arrow-path'"></mat-icon>
      </button>
    </div>

    <!-- Content -->
    <div
      class="bg-card relative flex flex-auto flex-col divide-y overflow-y-auto sm:max-h-120">
      <!-- Notifications -->
      @for (
        notification of notifications;
        track trackByFn($index, notification)
      ) {
        <div
          class="group flex hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5 p-4"
          [ngClass]="{ unread: notification.isUnread }"
          matTooltip="{{ notification.subject }}"
          matTooltipPosition="above">
          <!-- Notification with a link -->
          <a
            class="flex flex-auto cursor-pointer py-5"
            [routerLink]="
              notification.notificationType !== 'shipment'
                ? ''
                : ['/quote-requests/view', notification.docId]
            ">
            <ng-container
              *ngTemplateOutlet="
                notificationContent;
                context: { $implicit: notification }
              "></ng-container>
          </a>

          <!-- Actions -->
          <div
            class="notification-actions relative flex flex-col items-center justify-center space-y-4">
            <!-- Indicator for Mark as Read/Unread -->
            <button
              class="mark-read-button flex items-center justify-center h-10 w-10 hover:bg-gray-300 rounded-full"
              mat-icon-button
              (click)="toggleRead(notification)"
              [matTooltip]="
                notification.isUnread
                  ? ('notifications.markRead' | transloco)
                  : ('notifications.markUnread' | transloco)
              ">
              <span
                class="h-2 w-2 rounded-full"
                [ngClass]="{
                  'bg-gray-400 dark:bg-gray-500 sm:opacity-0 sm:group-hover:opacity-100':
                    !notification.isUnread,
                  'bg-primary': notification.isUnread,
                }"></span>
            </button>

            <!-- Remove Button -->
            <button
              class="remove-button flex items-center justify-center h-10 w-10 hover:bg-red-300 rounded-full"
              mat-icon-button
              (click)="delete(notification)"
              [matTooltip]="'notifications.remove' | transloco">
              <mat-icon
                class="text-red-600"
                [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
            </button>
          </div>
        </div>

        <!-- Notification content template -->
        <ng-template #notificationContent let-notification>
          <!-- Icon -->
          <div
            class="mr-4 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700">
            <mat-icon
              class="icon-size-5"
              [svgIcon]="
                notification.notificationType === 'shipment'
                  ? 'heroicons_outline:truck'
                  : notification.notificationType === 'account'
                    ? 'heroicons_outline:user-circle'
                    : 'heroicons_outline:bell'
              "></mat-icon>
          </div>
          <!-- Title, description & time -->
          <div class="flex flex-auto flex-col">
            <div
              class="line-clamp-1 font-semibold"
              [innerHTML]="notification.subject"></div>
            <div class="line-clamp-2" [innerHTML]="notification.message"></div>
            <div class="text-secondary mt-2 text-sm leading-none">
              {{ notification.date | date: 'MMM dd, h:mm a' }}
            </div>
          </div>
        </ng-template>
      }

      <!-- No notifications -->
      @if (!notifications || !notifications.length) {
        <div
          class="flex flex-auto flex-col items-center justify-center px-8 py-12 sm:justify-start">
          <div
            class="flex h-14 w-14 flex-0 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-600">
            <mat-icon
              class="text-primary-700 dark:text-primary-50"
              [svgIcon]="'heroicons_outline:bell'"></mat-icon>
          </div>
          <div class="mt-5 text-2xl font-semibold tracking-tight">
            {{ 'notifications.noneTitle' | transloco }}
          </div>
          <div class="text-secondary mt-1 w-full max-w-60 text-center text-md">
            {{ 'notifications.noneMessage' | transloco }}
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
